<template>
  <!--
    Per-supplier checkbox row.
    v-model gives the parent (SearchTab) an array of supplier codes to pass to the
    /operation/search request. Unchecking a supplier drops it from that array,
    so the parallel-stream fan-out simply doesn't fire for it — no backend change
    needed, the BFF already accepts any subset of suppliers.
  -->
  <div class="supplier-checkboxes">
    <span class="supplier-checkboxes__label">{{ $t("search-tab.suppliers") || "ספקים:" }}</span>
    <label
      v-for="supplier in options"
      :key="supplier"
      class="supplier-checkboxes__chip"
      :class="{ 'is-checked': isChecked(supplier) }"
    >
      <input type="checkbox" :checked="isChecked(supplier)" @change="toggle(supplier)" />
      <span class="supplier-checkboxes__name">{{ supplier }}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'SupplierCheckboxes',
  props: {
    // Two-way bind: the array of currently-selected supplier codes.
    value: { type: Array, required: true },
    // Full list of options; user can uncheck each one.
    options: { type: Array, required: true },
  },
  methods: {
    isChecked(supplier) {
      return this.value.includes(supplier);
    },
    toggle(supplier) {
      const next = this.isChecked(supplier)
        ? this.value.filter((s) => s !== supplier)
        : [...this.value, supplier];
      this.$emit('input', next);
    },
  },
};
</script>

<style scoped>
.supplier-checkboxes {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 0;
  font-size: 13px;
}
.supplier-checkboxes__label {
  color: #6b7d95;
  font-weight: 600;
  margin-inline-end: 4px;
}
.supplier-checkboxes__chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 999px;
  border: 1px solid #d7dee7;
  background: #f7f9fb;
  color: #6b7d95;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
  margin: 0;
  user-select: none;
}
.supplier-checkboxes__chip:hover {
  border-color: #b6c6da;
}
.supplier-checkboxes__chip.is-checked {
  background: #e6f0ff;
  border-color: #1f4c96;
  color: #1a3a5c;
}
.supplier-checkboxes__chip input[type="checkbox"] {
  width: 14px;
  height: 14px;
  accent-color: #1f4c96;
  cursor: pointer;
  margin: 0;
}
.supplier-checkboxes__name {
  font-weight: 700;
  letter-spacing: 0.02em;
}
</style>
